var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "tenders-comparison" } }, [
    _c("div", { attrs: { id: "tenders-comparison-data" } }, [
      _c("table", { staticClass: "excel" }, [
        _c("thead", [
          _c(
            "tr",
            [
              _c(
                "th",
                {
                  staticClass:
                    "title note column excel-title excel-block excel-intro excel-top-center",
                  staticStyle: { "text-align": "center", "min-width": "320px" },
                  attrs: { id: "table-title", rowspan: "2" },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("comparison.title")) +
                      "\n          "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.bids, function (bid, index) {
                return _c(
                  "th",
                  {
                    key: _vm.buildRandomKey(index),
                    staticClass:
                      "title column excel-title excel-block excel-top-center",
                    class: _vm.clsForCell(index),
                    staticStyle: { "text-align": "center" },
                    attrs: { colspan: "4" },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.deep(bid, "company.name") || "") +
                        "\n          "
                    ),
                  ]
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "tr",
            [
              _vm._l(_vm.bids, function (bid, index) {
                return [
                  _c(
                    "th",
                    {
                      key: _vm.buildRandomKey(index),
                      staticClass:
                        "title excel-subtitle excel-block excel-top-center",
                      class: _vm.clsForCell(index),
                      staticStyle: { "text-align": "center" },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("tender.section.qty")) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      key: _vm.buildRandomKey(index),
                      staticClass:
                        "title excel-subtitle excel-block excel-top-center",
                      class: _vm.clsForCell(index),
                      staticStyle: { "text-align": "center" },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("tender.section.unit")) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      key: _vm.buildRandomKey(index),
                      staticClass:
                        "title right excel-subtitle excel-block excel-top-center section-unit-rate",
                      class: _vm.clsForCell(index),
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("tender.section.unit")) +
                          " " +
                          _vm._s(_vm.$t("tender.section.rate")) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      key: _vm.buildRandomKey(index),
                      staticClass:
                        "title right excel-subtitle excel-block excel-top-center section-amount excel-amount",
                      class: _vm.clsForCell(index),
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("comparison.amount")) +
                          "/" +
                          _vm._s(_vm.currencyCode) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm._l(_vm.services, function (item, iIndex) {
              return [
                _c(
                  "tr",
                  { key: _vm.buildRandomKey(iIndex) },
                  [
                    _c(
                      "td",
                      {
                        staticClass:
                          "border-left-right bold excel-block excel-top-center",
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(String.fromCharCode(65 + iIndex)) +
                            "    " +
                            _vm._s(item.title) +
                            "\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.bids, function (bid, vIndex) {
                      return _c("td", {
                        key: vIndex,
                        staticClass: "border-right excel-block",
                        class: _vm.clsForCell(vIndex),
                        attrs: { colspan: "4" },
                      })
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._l(item.lineItems, function (lineItem, lIndex) {
                  return _c(
                    "tr",
                    { key: lIndex },
                    [
                      _c(
                        "td",
                        {
                          staticClass: "border-left-right excel-block",
                          staticStyle: {
                            "padding-left": "3rem",
                            "text-indent": "-1.5rem",
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(lineItem.itemNo) +
                              ". " +
                              _vm._s(lineItem.itemDesc) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.bids, function (bid, index) {
                        return [
                          _vm.isBidValid(bid)
                            ? [
                                _c(
                                  "td",
                                  {
                                    key: _vm.buildRandomKey(index),
                                    class: _vm.clsForCell(index),
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          bid.content.service.bidItemQtys[
                                            lineItem.id
                                          ] || lineItem.itemQty
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    key: _vm.buildRandomKey(index),
                                    class: _vm.clsForCell(index),
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(lineItem.itemUnit) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    key: _vm.buildRandomKey(index),
                                    staticClass:
                                      "right excel-number section-unit-rate",
                                    class: _vm.clsForCell(index),
                                    attrs: {
                                      "currency-for-excel":
                                        _vm.formatCurrencyForExcel(
                                          _vm.deep(
                                            bid,
                                            "content.service.bidItemRates." +
                                              lineItem.id
                                          ),
                                          _vm.notApplicable
                                        ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.formatAmount(
                                            _vm.deep(
                                              bid,
                                              "content.service.bidItemRates." +
                                                lineItem.id
                                            ),
                                            _vm.notApplicable
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    key: _vm.buildRandomKey(index),
                                    staticClass:
                                      "border-right right excel-number excel-block section-amount excel-amount",
                                    class: _vm.clsForCell(
                                      index,
                                      lineItem.total[bid.id] ===
                                        lineItem.total.min,
                                      lineItem.total[bid.id] ===
                                        lineItem.total.max
                                    ),
                                    attrs: {
                                      "currency-for-excel":
                                        _vm.formatCurrencyForExcel(
                                          lineItem.total[bid.id],
                                          _vm.notApplicable
                                        ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.formatAmount(
                                            lineItem.total[bid.id],
                                            _vm.notApplicable
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ]
                            : [
                                _c(
                                  "td",
                                  {
                                    key: _vm.buildRandomKey(index),
                                    class: _vm.clsForCell(index),
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.renderedEmptyValue(
                                            bid,
                                            iIndex,
                                            lIndex
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    key: _vm.buildRandomKey(index),
                                    class: _vm.clsForCell(index),
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.renderedEmptyValue(
                                            bid,
                                            iIndex,
                                            lIndex
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    key: _vm.buildRandomKey(index),
                                    staticClass:
                                      "right excel-number section-unit-rate",
                                    class: _vm.clsForCell(index),
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.renderedEmptyValue(
                                            bid,
                                            iIndex,
                                            lIndex
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    key: _vm.buildRandomKey(index),
                                    staticClass:
                                      "border-right right excel-number excel-block section-amount excel-amount",
                                    class: _vm.clsForCell(index),
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.renderedEmptyValue(
                                            bid,
                                            iIndex,
                                            lIndex
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ],
                        ]
                      }),
                    ],
                    2
                  )
                }),
                _vm._v(" "),
                _c(
                  "tr",
                  { key: _vm.buildRandomKey(iIndex) },
                  [
                    _c(
                      "td",
                      {
                        staticClass:
                          "border-top-right bold right excel-block excel-number",
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("comparison.subTotal")) +
                            " " +
                            _vm._s(String.fromCharCode(65 + iIndex)) +
                            _vm._s(
                              item.forReference
                                ? "(" +
                                    _vm.$t("tender.section.notIncluded") +
                                    ")"
                                : ""
                            ) +
                            "\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.bids, function (bid, vIndex) {
                      return [
                        _c("td", {
                          key: _vm.buildRandomKey(vIndex),
                          class: _vm.clsForCell(vIndex),
                          attrs: { colspan: "2" },
                        }),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            key: _vm.buildRandomKey(vIndex),
                            staticClass: "bold right excel-number",
                            class: _vm.clsForCell(vIndex),
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  "" +
                                    _vm.formatPercentage(
                                      item.subTotalPercentage[bid.id]
                                    )
                                ) +
                                "\n              "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            key: _vm.buildRandomKey(vIndex),
                            staticClass:
                              "border-top-right bold right excel-number excel-block",
                            class: _vm.clsForCell(vIndex),
                            attrs: {
                              "currency-for-excel": _vm.formatCurrencyForExcel(
                                item.subTotal[bid.id],
                                _vm.notApplicable
                              ),
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.isBidValid(bid) &&
                                    item.subTotal[bid.id] !== _vm.notApplicable
                                    ? _vm.formatAmount(item.subTotal[bid.id]) +
                                        " "
                                    : _vm.notApplicable
                                ) +
                                "\n              "
                            ),
                          ]
                        ),
                      ]
                    }),
                  ],
                  2
                ),
              ]
            }),
            _vm._v(" "),
            _vm.showOthers
              ? [
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticClass:
                            "border-left-right bold excel-block excel-top-center",
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("others")) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.bids, function (bid, vIndex) {
                        return _c("td", {
                          key: vIndex,
                          staticClass: "border-right excel-block",
                          class: _vm.clsForCell(vIndex),
                          attrs: { colspan: "4" },
                        })
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticClass: "border-left-right excel-block",
                          staticStyle: {
                            "padding-left": "3rem",
                            "text-indent": "-1.5rem",
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("description")) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.bids, function (bid, index) {
                        return [
                          _vm.isBidValid(bid)
                            ? _c(
                                "td",
                                {
                                  key: _vm.buildRandomKey(index),
                                  staticClass: "border-right",
                                  class: _vm.clsForCell(index),
                                  attrs: { colspan: "4" },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.deep(
                                          bid,
                                          "content.service.otherItem.desc"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              )
                            : _c(
                                "td",
                                {
                                  key: _vm.buildRandomKey(index),
                                  staticClass: "border-right",
                                  class: _vm.clsForCell(index),
                                  attrs: { colspan: "4" },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.emptyValue) +
                                      "\n              "
                                  ),
                                ]
                              ),
                        ]
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticClass: "border-left-right excel-block",
                          staticStyle: {
                            "padding-left": "3rem",
                            "text-indent": "-1.5rem",
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("comparison.amount")) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.bids, function (bid, index) {
                        return [
                          _vm.isBidValid(bid)
                            ? [
                                _c(
                                  "td",
                                  {
                                    key: _vm.buildRandomKey(index),
                                    class: _vm.clsForCell(index),
                                  },
                                  [
                                    _vm._v(
                                      "\n                  1\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    key: _vm.buildRandomKey(index),
                                    class: _vm.clsForCell(index),
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Lot\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    key: _vm.buildRandomKey(index),
                                    staticClass: "right excel-number",
                                    class: _vm.clsForCell(index),
                                    attrs: {
                                      "currency-for-excel":
                                        _vm.formatCurrencyForExcel(
                                          _vm.deep(
                                            bid,
                                            "content.service.otherItem.rate"
                                          ),
                                          _vm.notApplicable
                                        ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.formatAmount(
                                            _vm.deep(
                                              bid,
                                              "content.service.otherItem.rate"
                                            ),
                                            _vm.notApplicable
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    key: _vm.buildRandomKey(index),
                                    staticClass:
                                      "border-right right excel-number excel-block",
                                    class: _vm.clsForCell(index),
                                    attrs: {
                                      "currency-for-excel":
                                        _vm.formatCurrencyForExcel(
                                          _vm.deep(
                                            bid,
                                            "content.service.otherItem.rate"
                                          )
                                        ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.formatAmount(
                                            _vm.deep(
                                              bid,
                                              "content.service.otherItem.rate"
                                            )
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ]
                            : [
                                _c(
                                  "td",
                                  {
                                    key: _vm.buildRandomKey(index),
                                    class: _vm.clsForCell(index),
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.emptyValue) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    key: _vm.buildRandomKey(index),
                                    class: _vm.clsForCell(index),
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.emptyValue) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    key: _vm.buildRandomKey(index),
                                    staticClass: "right excel-number",
                                    class: _vm.clsForCell(index),
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.emptyValue) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    key: _vm.buildRandomKey(index),
                                    staticClass:
                                      "border-right right excel-number excel-block",
                                    class: _vm.clsForCell(index),
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.emptyValue) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ],
                        ]
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticClass:
                            "border-top-right bold right excel-block excel-number",
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("comparison.subTotal")) +
                              " " +
                              _vm._s(_vm.$t("others")) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.bids, function (bid, vIndex) {
                        return [
                          _c("td", {
                            key: _vm.buildRandomKey(vIndex),
                            class: _vm.clsForCell(vIndex),
                            attrs: { colspan: "2" },
                          }),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              key: _vm.buildRandomKey(vIndex),
                              staticClass: "bold right excel-number",
                              class: _vm.clsForCell(vIndex),
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    "" +
                                      _vm.formatPercentage(
                                        _vm.deep(
                                          bid,
                                          "content.service.otherItemPercentage"
                                        )
                                      )
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              key: _vm.buildRandomKey(vIndex),
                              staticClass:
                                "border-top-right bold right excel-number excel-block",
                              class: _vm.clsForCell(vIndex),
                              attrs: {
                                "currency-for-excel":
                                  _vm.formatCurrencyForExcel(
                                    _vm.deep(
                                      bid,
                                      "content.service.otherItem.rate"
                                    ),
                                    _vm.notApplicable
                                  ),
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.isBidValid(bid)
                                      ? "" +
                                          _vm.formatAmount(
                                            _vm.deep(
                                              bid,
                                              "content.service.otherItem.rate"
                                            )
                                          )
                                      : _vm.notApplicable
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.showOtherItems
              ? [
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticClass:
                            "border-left-right bold excel-block excel-top-center",
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("others")) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.bids, function (bid, vIndex) {
                        return _c("td", {
                          key: _vm.buildRandomKey(vIndex),
                          staticClass: "border-right excel-block",
                          class: _vm.clsForCell(vIndex),
                          attrs: { colspan: "4" },
                        })
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.bidItemContent, function (item, cIndex) {
                    return [
                      _c(
                        "tr",
                        { key: _vm.buildRandomKey(cIndex) },
                        [
                          _c(
                            "td",
                            {
                              staticClass: "border-left-right excel-block",
                              staticStyle: {
                                "padding-left": "3rem",
                                "text-indent": "-1.5rem",
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(cIndex + 1) +
                                  ". " +
                                  _vm._s(_vm.$t("description")) +
                                  "\n              "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(item, function (content, tIndex) {
                            return [
                              _vm.isValidateOtherContent(content)
                                ? _c(
                                    "td",
                                    {
                                      key: _vm.buildRandomKey(tIndex),
                                      staticClass: "border-right excel-block",
                                      class: _vm.clsForCell(tIndex),
                                      attrs: { colspan: "4" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            content
                                              ? _vm.deep(content, "itemDesc")
                                              : _vm.notApplicable
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "td",
                                    {
                                      key: _vm.buildRandomKey(tIndex),
                                      staticClass: "border-right excel-block",
                                      class: _vm.clsForCell(tIndex),
                                      attrs: { colspan: "4" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.emptyValue) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                            ]
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "tr",
                        { key: _vm.buildRandomKey(cIndex) },
                        [
                          _c(
                            "td",
                            {
                              staticClass: "border-left-right excel-block",
                              staticStyle: {
                                "padding-left": "3rem",
                                "text-indent": "-1.5rem",
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("comparison.amount")) +
                                  "\n              "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(item, function (content, tIndex) {
                            return [
                              _vm.isValidateOtherContent(content)
                                ? [
                                    _c(
                                      "td",
                                      {
                                        key: _vm.buildRandomKey(tIndex),
                                        class: _vm.clsForCell(tIndex),
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              content
                                                ? _vm.deep(content, "itemQty")
                                                : _vm.notApplicable
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        key: _vm.buildRandomKey(tIndex),
                                        class: _vm.clsForCell(tIndex),
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              content
                                                ? _vm.deep(content, "itemUnit")
                                                : _vm.notApplicable
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        key: _vm.buildRandomKey(tIndex),
                                        staticClass: "right excel-number",
                                        class: _vm.clsForCell(tIndex),
                                        attrs: {
                                          "currency-for-excel":
                                            _vm.formatCurrencyForExcel(
                                              _vm.deep(content, "rate"),
                                              _vm.notApplicable
                                            ),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.formatAmount(
                                                _vm.deep(content, "rate"),
                                                _vm.notApplicable
                                              )
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        key: _vm.buildRandomKey(tIndex),
                                        staticClass:
                                          "border-right right excel-number excel-block",
                                        class: _vm.clsForCell(tIndex),
                                        attrs: {
                                          "currency-for-excel":
                                            _vm.formatCurrencyForExcel(
                                              _vm.deep(content, "total"),
                                              _vm.notApplicable
                                            ),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.formatAmount(
                                                _vm.deep(content, "total"),
                                                _vm.notApplicable
                                              )
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                  ]
                                : [
                                    _c(
                                      "td",
                                      {
                                        key: _vm.buildRandomKey(tIndex),
                                        class: _vm.clsForCell(tIndex),
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.emptyValue) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        key: _vm.buildRandomKey(tIndex),
                                        class: _vm.clsForCell(tIndex),
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.emptyValue) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        key: _vm.buildRandomKey(tIndex),
                                        staticClass: "right excel-number",
                                        class: _vm.clsForCell(tIndex),
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.emptyValue) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        key: _vm.buildRandomKey(tIndex),
                                        staticClass:
                                          "border-right right excel-number excel-block",
                                        class: _vm.clsForCell(tIndex),
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.emptyValue) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                            ]
                          }),
                        ],
                        2
                      ),
                    ]
                  }),
                  _vm._v(" "),
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticClass:
                            "border-top-right bold right excel-block excel-number",
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("comparison.subTotal")) +
                              " " +
                              _vm._s(_vm.$t("others")) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.bids, function (bid, vIndex) {
                        return [
                          _c("td", {
                            key: _vm.buildRandomKey(vIndex),
                            class: _vm.clsForCell(vIndex),
                            attrs: { colspan: "2" },
                          }),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              key: _vm.buildRandomKey(vIndex),
                              staticClass: "bold right excel-number",
                              class: _vm.clsForCell(vIndex),
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    "" +
                                      _vm.formatPercentage(
                                        _vm.deep(
                                          bid,
                                          "content.service.multiOtherItemsPercentage"
                                        )
                                      )
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              key: _vm.buildRandomKey(vIndex),
                              staticClass:
                                "border-top-right bold right excel-number excel-block",
                              class: _vm.clsForCell(vIndex),
                              attrs: {
                                "currency-for-excel":
                                  _vm.formatCurrencyForExcel(
                                    _vm.formatOtherTotalFee(bid),
                                    _vm.notApplicable
                                  ),
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.showAmount(bid)) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.showDiscount
              ? [
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticClass:
                            "bold right border-right excel-block excel-number",
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("comparison.totalBeforeDiscount")) +
                              "(" +
                              _vm._s(_vm.$t("comparison.hk")) +
                              "$)\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.bids, function (bid, vIndex) {
                        return [
                          _vm.isBidValid(bid)
                            ? _c(
                                "td",
                                {
                                  key: _vm.buildRandomKey(vIndex),
                                  staticClass:
                                    "bold border-right right excel-number excel-block",
                                  class: _vm.clsForCell(vIndex),
                                  attrs: { colspan: "4" },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.formatAmount(
                                          bid.content.service
                                            .totalBeforeDiscount
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              )
                            : _c(
                                "td",
                                {
                                  key: _vm.buildRandomKey(vIndex),
                                  staticClass:
                                    "bold border-right right excel-number excel-block",
                                  class: _vm.clsForCell(vIndex),
                                  attrs: { colspan: "4" },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.notApplicable) +
                                      "\n              "
                                  ),
                                ]
                              ),
                        ]
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticClass:
                            "bold right border-right excel-block excel-number",
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("comparison.discount")) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.bids, function (bid, vIndex) {
                        return [
                          _vm.isBidValid(bid)
                            ? _c(
                                "td",
                                {
                                  key: _vm.buildRandomKey(vIndex),
                                  staticClass:
                                    "bold border-right right excel-number excel-block",
                                  class: _vm.clsForCell(vIndex),
                                  attrs: { colspan: "4" },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.formatDiscount(
                                          bid.content.service.discountValue,
                                          bid.content.service.discountType
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              )
                            : _c(
                                "td",
                                {
                                  key: _vm.buildRandomKey(vIndex),
                                  staticClass:
                                    "bold border-right right excel-number excel-block",
                                  class: _vm.clsForCell(vIndex),
                                  attrs: { colspan: "4" },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.notApplicable) +
                                      "\n              "
                                  ),
                                ]
                              ),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "tr",
              [
                _c(
                  "td",
                  {
                    staticClass:
                      "bold right border-right excel-block excel-number",
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("tender.section.total")) +
                        "\n          "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.bids, function (bid, vIndex) {
                  return [
                    _vm.isBidValid(bid)
                      ? _c(
                          "td",
                          {
                            key: _vm.buildRandomKey(vIndex),
                            staticClass:
                              "bold border-right right excel-number excel-block",
                            class: _vm.clsForCell(
                              vIndex,
                              bid.content.service.totalFee === _vm.min,
                              bid.content.service.totalFee === _vm.max
                            ),
                            attrs: {
                              colspan: "4",
                              "currency-for-excel": _vm.formatCurrencyForExcel(
                                bid.content.service.totalFee
                              ),
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.formatAmount(bid.content.service.totalFee)
                                ) +
                                "\n            "
                            ),
                          ]
                        )
                      : _c(
                          "td",
                          {
                            key: _vm.buildRandomKey(vIndex),
                            staticClass:
                              "bold border-right right excel-number excel-block",
                            class: _vm.clsForCell(vIndex),
                            attrs: { colspan: "4" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.notApplicable) +
                                "\n            "
                            ),
                          ]
                        ),
                  ]
                }),
              ],
              2
            ),
            _vm._v(" "),
            _vm.shouldShowRemarksRow
              ? _c(
                  "tr",
                  { staticClass: "vendor-remarks" },
                  [
                    _c(
                      "td",
                      {
                        staticClass:
                          "bold right border-right excel-block excel-number",
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("comparison.vendorRemarks")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.vendorRemarks, function (remark, vIndex) {
                      return [
                        _c(
                          "td",
                          {
                            key: _vm.buildRandomKey(vIndex),
                            staticClass:
                              "border-right right excel-block wrap-cell",
                            attrs: { colspan: "4" },
                          },
                          [
                            _c("pre", {
                              domProps: { innerHTML: _vm._s(remark) },
                            }),
                          ]
                        ),
                      ]
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "actions" }, [
      _c(
        "button",
        {
          staticClass: "btn btn--orange",
          attrs: { type: "button" },
          on: { click: _vm.onExport },
        },
        [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("comparison.exportToExcel")) + "\n    "
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }